import React from 'react';
import { colors } from '../constants';

function AddIcon({ color, size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 17.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15zm0 1.5a9 9 0 100-18 9 9 0 000 18zm-4.75-9A.75.75 0 016 9.25h3.25V6a.75.75 0 011.5 0v3.25H14a.75.75 0 010 1.5h-3.25V14a.75.75 0 01-1.5 0v-3.25H6a.75.75 0 01-.75-.75z"
        fill={color}
      />
    </svg>
  );
}

AddIcon.defaultProps = {
  color: colors.mediumGrey,
  size: 20,
};

export default AddIcon;
